import RelatedOrgInfo from '../grid/cells/RelatedOrgInfo'

const OrganizationRelatedOrgs = () => {
  return <RelatedOrgInfo />
}

export default OrganizationRelatedOrgs
